import { Observable } from 'rxjs';
import { Collection, ICollectionConfig } from '../../../abstract';

export type IMusimapCollectionConfig = ICollectionConfig;

export enum MusimapCollectionProps {
  ITEM_ID = '__itemId',
  PARENT_COLLECTION = '__parentCollection',
  PARENT_ITEM = '__parentItem',
  CHILD_COLLECTION = '__childCollection',
  IS_SELECTED = '__isSelected',
  SOURCE = '__source',
  ORIGINAL_VALUE = '__original',
  OBSERVABLE_STATE = '__isSelectedObservable'
}

export enum MusimapCollectionMethods {
  TOGGLE = '__toggle',
  SELECT = '__select',
  DESELECT = '__deselect',
  CREATE_CHILD_COLLECTION = '__createChildCollection'
}

export class MusimapCollection<T> extends Collection<T> {}

export const getZippedItems = <T>(d: MusimapCollection<T>, includeParent: boolean = false): T[] => {
  const items: T[] = [];

  d.getItems().forEach(item => {
    const childCollection: MusimapCollection<T> = item[MusimapCollectionProps.CHILD_COLLECTION];

    if (includeParent) {
      items.push(item);
    }

    if (childCollection) {
      childCollection.getItems().forEach(childItem => items.push(childItem));
    }
  });

  return items;
};

export const getZippedCollections = <T>(
  d: MusimapCollection<T>,
  includeParent: boolean = false
): MusimapCollection<T>[] => {
  const collections: MusimapCollection<T>[] = [];

  if (includeParent) {
    collections.push(d);
  }

  d.getItems().forEach(item => {
    const collection = item[MusimapCollectionProps.CHILD_COLLECTION];
    if (collection) {
      collections.push(collection);
    }
  });

  return collections;
};

export const getZippedSelection = <T>(d: MusimapCollection<T>, includeParent: boolean = false): T[] => {
  const items: T[] = [];
  d.getItems().forEach(item => {
    if (includeParent && item[MusimapCollectionProps.IS_SELECTED]) {
      items.push(item);
    }
    const childCollection: MusimapCollection<T> = item[MusimapCollectionProps.CHILD_COLLECTION];
    (childCollection?.selection || []).forEach(childItem => items.push(childItem));
  });
  return items;
};

export const getCollectionChildrenAsObservables = <T>(d: MusimapCollection<T>): Observable<T[]>[] => {
  const observables: Observable<T[]>[] = [];
  d.getItems().forEach(item => {
    const childCollection: MusimapCollection<T> = item[MusimapCollectionProps.CHILD_COLLECTION];
    if (childCollection) {
      observables.push(childCollection.onSelect());
    }
  });
  return observables;
};
